/**
 * Typed access to the build-time environment.
 *
 * `import.meta.env` is `any` outside a Vite-aware type context, which turns
 * every read into an unchecked value. Reading it once, here, keeps that
 * looseness in a single place.
 */
interface ViteEnv {
  VITE_DATA_API_URL?: string;
  VITE_GOOGLE_CLIENT_ID?: string;
}

export function viteEnv(): ViteEnv {
  return import.meta.env as ViteEnv;
}
